import React, { useEffect, useState } from 'react'
import { Rating } from '../components/Elements/Rating'
import { useParams } from 'react-router-dom'
import { useSearch } from '../store/context/SearchContext'
import { ReviewSection } from './Review';
import { useClerk } from '@clerk/clerk-react';


export const ProductDetail = () => {
  const { user } = useClerk();

const [product, setProduct] = useState()
const [loading, setLoading] = useState(true)
const {id} = useParams()
const {addItem} = useSearch()

console.log("id is here", id)

useEffect(()=>{
  const getProductById = async () => {
    try {
     //========================the new going first to strapi CMS=====START==================================
      // const get_Product_Netlify_Strapi_Xata = await fetch(`/.netlify/functions/cmsComunecation` , {

        const get_Product_Netlify_Strapi_Xata = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products?populate[poster][populate]=*&filters[p_id][$eq]=${id}`)
        // const get_Product_Netlify_Strapi_Xata = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/products?populate[poster][populate]=*&filters[p_id][$eq]=${id}`)
        
      const back_data = await get_Product_Netlify_Strapi_Xata.json()
      setLoading(false)
      console.log(" from ProductDetail line 33 ==================================>",
                                  back_data.data[0].long_Description[0].children[0].text);
                                 
      setProduct(back_data.data[0])
    
    
     //========================the new going first to strapi CMS=====END==================================
     // =======================the xata direct code======start========================================= 
      // const get_Product_Netlify_Serverless = await fetch(`/.netlify/functions/getProducts`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json",
      //    },
      //   body: JSON.stringify({
      //     request_type: "get_product_by_id",
      //      id: id
      //     })
      // });
      // const data = await get_Product_Netlify_Serverless.json()
      // if(get_Product_Netlify_Serverless.ok){
      //   setLoading(false)
      //   console.log("data is here", data[0])
      //   setProduct(data)
    
      // }
    } catch (error) {
      console.error("Error fetching XATA data", error);
    } finally {
    }
     // =======================the xata direct code======end========================================= 
  
  };
  getProductById()
},[id])
 
if(loading) {
  return <div>loading...</div>
}

if(!product) {
  return <div>product not found</div>
}

const passProductsToDb = async () => {
  let new_user_cart = [];
  // let userLoggedIn = "null"
  if(user){
    console.log("user is here", user)
     console.log("productsList from productDetail", product)

//  const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
    const get_user_data = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`)
  

     const get_user = await get_user_data.json();
console.log( "get_user", get_user);

     const new_user_doc_id = get_user.data[0].documentId
      const new_user_firstName = get_user.data[0].first_name
      const new_user_email = get_user.data[0].email
      const new_user_lastName = get_user.data[0].last_name
      const new_user_uId = get_user.data[0].u_id
      const new_user_ImageUrl = get_user.data[0].image_url

     if(get_user.data[0].cart !== undefined && get_user.data[0].cart !== null/*&& get_user.data[0].cart.length >= 1*/){
       get_user.data[0].cart.map((item)=>
         new_user_cart.push(item)
       )
      
     }
     new_user_cart.push(product)
 // const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users/${new_user_doc_id}`, {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users/${new_user_doc_id}`, {
       method: "PUT",
       headers: {
         "Content-Type": "application/json",
       },
       body: JSON.stringify({
         data: {
           first_name: new_user_firstName,
           email: new_user_email,
           last_name: new_user_lastName,
           u_id: new_user_uId,
           image_url: new_user_ImageUrl,
           cart: new_user_cart
         },
       }),
     });
     const dataIn = await res.json();
     console.log("cart products is Here", dataIn);
    //  return {
    //    statusCode: 200,
    //    body: JSON.stringify({ message: "cart products is Here " }),
    //  };

    //  const userInfo = await fetch("/.netlify/functions/userHandler", {
    //    method: "POST",
    //    headers: { "Content-Type": "application/json",
    //     },
    //    body: JSON.stringify({
    //      request_type: "cart_products",
    //       products: product, 
    //       user_info: user
    //      })
    //  })


    //  const data = await userInfo.json();
    //  console.log("userInfo from google auth", data)
  }
  else{
    
    console.log("user is not here")
    localStorage.setItem(`product_${product.p_id}`, JSON.stringify(product))
    // userLoggedIn = "null"
  }
 
}


function handleAddToCart(){
  addItem(product)
  passProductsToDb()
}

  return (
    <main>
    <section>
      <h1 className="mt-10 mb-5 text-4xl text-center font-bold text-gray-900 dark:text-slate-200">{ product.name }</h1>
      <p className="mb-5 text-lg text-center text-gray-900 dark:text-slate-200 max-w-[800px] m-auto ">{ product.over_view }</p>
      <div className="flex flex-wrap justify-around">
        <div className="max-w-xl my-3">
          {/* <img className="rounded" src={`${process.env.REACT_APP_BACKEND_URL_LOCAL}` + product.poster.url } alt={product.name} />  */}
          <img className="rounded" src={`${process.env.REACT_APP_BACKEND_URL}` + product.poster.url } alt={product.name} /> 
        </div>
        <div className="max-w-xl my-3">
          <p className="text-3xl font-bold text-gray-900 dark:text-slate-200">
            <span className="mr-1">$</span>
            <span className="">{ product.price }</span>
          </p>
          <p className="my-3"> 
            <span>
              <Rating rating={product.rating } />
            </span>
          </p>
          <p className="my-4 select-none">
           { product.best_seller && <span className="font-semibold text-amber-500 border bg-amber-50 rounded-lg px-3 py-1 mr-2">BEST SELLER</span> }
            { product.in_stock && <span className="font-semibold text-emerald-600	border bg-slate-100 rounded-lg px-3 py-1 mr-2">INSTOCK</span> }
            { !product.in_stock && <span className="font-semibold text-rose-700 border bg-slate-100 rounded-lg px-3 py-1 mr-2">OUT OF STOCK</span> }
            <span className="font-semibold text-blue-500 border bg-slate-100 rounded-lg px-3 py-1 mr-2">{ product.size } MB</span>
          </p>
          <p className="my-3">
         <button onClick={handleAddToCart}  className='bg-slate-500 rounded-lg px-3'>Add To Cart</button>    
          </p>
          <div className="text-lg text-gray-900 dark:text-slate-200">
            {product.long_Description.map((item , index)=>(<div className='text-left' key={index}>{item.children[0].text}</div> )) }
          </div>
         <ReviewSection productId={product.id} initialReviews={product.reviews} /> 
        </div>
      </div>
    </section>

  </main>
  )
}


